import { render } from "./StorefrontControlBar.vue?vue&type=template&id=2367a8d0&scoped=true"
import script from "./StorefrontControlBar.vue?vue&type=script&lang=js"
export * from "./StorefrontControlBar.vue?vue&type=script&lang=js"

import "./StorefrontControlBar.vue?vue&type=style&index=0&id=2367a8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2367a8d0"]])

export default __exports__